
export const environment = {
  production: false,
  commitHash: 'e9f6db1',
  commitDate: 'Thu Oct 22 00:38:18 2026 -0500',
  deployDate: '2026-10-22T05:44:43Z',
  apiUrl: 'http://localhost:8080',
  paypalClientId: 'AZlcAYm2oQZoYlK1IH384ZOiLUc0r1tqhhc0j-oslOD_wCJcQkFYVP2Qv2hyGQ191SswW0begTVYUT2i',
  recaptchaV3SiteKey: '',
  recaptchaV2SiteKey: '',
  appVersion: 'local-dev',
  // Local dev: empty DSN disables Sentry entirely (no-op).
  // The Sentry "environment" tag is derived at runtime from window.location.hostname
  // in src/main.ts, so we don't need to plumb it through here.
  sentry: {
    dsn: '',
    tracesSampleRate: 0,
  },
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
